import { ModalidadeParticipante } from 'enum';

export const languageValues = {
  pages: {
    home: {
      title: 'Olá, seja bem-vindo(a)!',
      subtitle:
        'Para confirmar sua participação preencha com seu CPF o campo abaixo e confirme.',
      perguntaModalidade: 'Como você está participando do evento?',
      input: {
        label: 'CPF',
        placeholder: 'Digite seu CPF...',
      },
    },
    presenca: {
      title: 'Confirmar Presença',
      subtitle:
        'Confirme sua presença para as contas as quais você é Representante Legal:',
      table: {
        presenca: 'Presença',
        conta: 'Conta',
        agencia: 'Agência',
        nome: 'Nome do associado',
      },
    },
    agradecimento: {
      title: 'Sua presença foi registrada com sucesso!',
      subtitle: 'É um prazer tê-lo(a) aqui conosco.',
    },
    naoAssociado: {
      title: 'Olá, seja bem-vindo(a)!',
      subtitleCrescer:
        'Para confirmar sua participação na formação do Programa Crescer, preencha seu CPF no campo abaixo e confirme.',
      agradecimento: {
        title: 'Agradecemos seu interesse!',
        subtitle: 'No momento esta formação é exclusiva para associados.',
      },
      termoCrescer: {
        texto:
          'Cumprindo com as exigências da Lei 13.709/18, Lei Geral de Proteção de Dados (LGPD), AUTORIZO que meus\n' +
          'dados pessoais (nome e CPF), sejam utilizados para a finalidade de registro de presença na formação no\n' +
          'Programa Crescer. As informações serão utilizadas pelo período de 05 anos. Após o término do período de\n' +
          'vigência e/ou da sua utilização os dados serão excluídos.',
        erro:
          'Sua participação na turma\n' +
          'do Programa Crescer não será confirmada. Caso deseje prosseguir com seu registro, é necessário autorizar o\n' +
          'uso dos dados: Nome e CPF.',
      },

      termo: {
        texto:
          'Cumprindo com as exigências da Lei 13.709/18, Lei Geral de Proteção de Dados (LGPD), AUTORIZO que meus\n' +
          'dados pessoais (nome e CPF), sejam utilizados para a finalidade de registro de presença na formação dos\n' +
          'Programas e Iniciativas da Fundação Sicredi. As informações serão utilizadas pelo período de 05 anos. Após o término do período de\n' +
          'vigência e/ou da sua utilização os dados serão excluídos.',
        erro:
          'Sua participação no evento\n' +
          'não será confirmada. Caso deseje prosseguir com seu registro, é necessário autorizar o\n' +
          'uso dos dados: Nome e CPF.',
      },

      input: {
        cpf: {
          label: 'CPF',
          placeholder: 'Digite seu CPF...',
        },
        nome: {
          label: 'Nome',
          placeholder: 'Digite seu nome completo...',
        },
        agencia: {
          label: 'Agência:',
          placeholder: 'Selecione uma agência:',
        },
        cooperativa: {
          label: 'Cooperativa:',
          placeholder: 'Selecione uma cooperativa:',
        },
        cep: {
          label: 'CEP',
          // TODO: não seria melhor se essa info fosse um hint?
          placeholder: 'Informe o CEP para localizar a agência participante',
        },
      },
      eventoSistemico: {
        radio: {
          title:
            'Escolha uma das opções abaixo para informar onde ocorreu o evento',
          informarLabel: 'Informe por cooperativa e agência',
          localizarLabel: 'Localize agência pelo CEP',
        },
      },
    },
    notFound: {
      title: 'Página não encontrada!',
    },
  },
  buttons: {
    confirm: 'Confirmar',
    initialPage: 'Página Inicial',
    cancel: 'Cancelar',
    modalidae: {
      [ModalidadeParticipante.Online]: 'On-line',
      [ModalidadeParticipante.Presencial]: 'Presencial',
      [ModalidadeParticipante.Hibrido]: 'Híbrido',
    },
  },
  erros: {
    generico: 'Houve um erro. Entre em contato com o suporte.',
    recaptchaFallback:
      'Para confirmar sua participação, marque a opção "Não sou um robô" e clique em confirmar.',
  },
};
